import SimpleDate from "app/common/classes/simple-date"
import { Simplify } from "app/common/types/_utilities/simplify"

export enum SubsidiesGroupedSection {
  RestFood = 'rest_food',
}
export type DocumentGroupedSubsidiesType = {
  title: string,
  address: string,
  phone: string,
  school: string,
  month: string,
  year: string,
  director: string,
  assistant: string,
  manager: string
}

export type KlassesTitle = string

export type KlassesGroupedType = {
  title: KlassesTitle
  sum: string,
  count: number,
  students: Array<number>
}

export type GroupedTotalDataType = {
  klasses: Array<KlassesGroupedType>,
  dayCares: Array<KlassesGroupedType>,
  sum: string,
  count: number,
  students: Array<number>
}

export type ColsGroupedDataType = {
  dayCares: Array<string>,
  klasses: Array<string>
}

export type RowGroupedData = Simplify<
  { date: SimpleDate } & GroupedTotalDataType
>

export type SubsidyGroupedSummaryType = {
  sum: string,
  count: number,
  klasses: { sum: string, count: number },
  dayCares: { sum: string, count: number }
}


export type ReportSubsidiesGroupedData = {
  section: SubsidiesGroupedSection.RestFood,
  document: DocumentGroupedSubsidiesType,
  dateFrom: SimpleDate
  dateTo: SimpleDate
  cols: ColsGroupedDataType,
  rows: Array<RowGroupedData>
  total: GroupedTotalDataType,
  summary: SubsidyGroupedSummaryType
}
